<p-dropdown
    class="w-100"
    styleClass="w-100"
    inputStyleClass="w-100"
    appendTo="body"
    dataKey="studentId"
    [filter]="showFilter"
    filterBy="name,surname"
    [placeholder]="placeholder"
    [showClear]="showClear"
    [options]="students"
    [(ngModel)]="selected"
    (ngModelChange)="onSelectionChange()">

    <ng-template let-item pTemplate="selectedItem">
        <div class="flex align-items-center gap-2">
            <span>{{item.name}} {{item.surname}}</span>
        </div>
    </ng-template>

    <ng-template let-item pTemplate="item">
        <div class="flex align-items-center gap-2">
            <span>{{item.name}} {{item.surname}}</span>
        </div>
    </ng-template>

</p-dropdown>

